(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["location-map"] && !Shopify.designMode) return;
  try {
    
/* Lazy map. The iframe is never in the HTML — it is built here, either when
   the frame scrolls into view or when the reader asks for it. Keeps roughly a
   megabyte of Google off the critical path. */
(function () {
  function build(frame) {
    if (frame.querySelector('iframe')) return;

    var src = frame.getAttribute('data-map-src');
    if (!src) return;

    var f = document.createElement('iframe');
    f.src = src;
    f.title = frame.getAttribute('data-map-title') || 'Location map';
    f.loading = 'lazy';
    f.setAttribute('allowfullscreen', '');
    f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    f.addEventListener('load', function () {
      frame.classList.add('is-loaded');
    });

    frame.appendChild(f);
  }

  function init() {
    var frames = document.querySelectorAll('[data-map]:not([data-map-ready])');

    Array.prototype.forEach.call(frames, function (frame) {
      frame.setAttribute('data-map-ready', '');

      var btn = frame.querySelector('[data-map-load]');
      if (btn) {
        btn.addEventListener('click', function () {
          build(frame);
        });
      }

      if (frame.getAttribute('data-map-mode') === 'click') return;

      if (!('IntersectionObserver' in window)) {
        build(frame);
        return;
      }

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.disconnect();
            build(frame);
          });
        },
        { rootMargin: '400px' }
      );

      io.observe(frame);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
